export class PageLayoutComponent {
  constructor(difference) {
    this.createBlockTimes = 0
    this.styleName = "布局"
    this.childrenRect = []
    this.innerElement = "cxPageLayoutComponent"
    this.thumbnail = require("../../../assets/images/homeLeftMenu/base/icon_auto_layout_v.png")
    this.width = 100
    this.height = 240
    this.top = 10
    this.left = 10
    this.widthType = "%" // px   %  自动
    this.heightType = "自动" // px   %  自动
    this.sizeType = "px"
    this.layoutType = "auto"
    this.direction = "vertical" // vertical  horizon
    this.alignPositionH = "left" // left center right
    this.alignPositionV = "top" // top middle bottom
    this.marginBottom = 0
    this.opacity = 100
    this.noCacheComponent = false
    this.updateTimer = 100
    this.reverseGetColsUid = false
    this.elementOptions = []
    this.isFullHeight = false // 在开启了整屏切换的情况下，通过该标识来自动将高度设置为window.innerHeight
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
